import { ApiFormTemplate } from "@/types/forms/form-template.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { PerformanceReviewTemplateEditPageStep } from "@/pages/talent/performance-reviews/templates/edit/performance-review-template-edit.tsx";

export interface PerformanceReviewTemplateEditSidebarProps {
  step: PerformanceReviewTemplateEditPageStep;
  template?: ApiFormTemplate;
}

export const PerformanceReviewTemplateEditSidebar = ({
  step,
  template,
}: PerformanceReviewTemplateEditSidebarProps) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      step: PerformanceReviewTemplateEditPageStep.details,
      title: t("common:details"),
    },
    {
      step: PerformanceReviewTemplateEditPageStep.questions,
      title: t("common:questionnaire"),
    },
  ];
  const currentStepIndex = menuItems.findIndex((item) => item.step === step);

  return (
    <Stack className={"px-6"} gap={"md"}>
      {menuItems.map((item, itemIndex) => {
        const className = step === item.step ? "text-default" : "text-secondary";
        const isLinkAvailable =
          template && (itemIndex < currentStepIndex || template.title.length > 0);

        if (!isLinkAvailable) {
          return (
            <Text key={item.step} className={className}>
              {item.title}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item.step}
            to={`/templates/performance-reviews/${template.id}/setup/${item.step}`}
            variant={"plain"}
            className={className}
          >
            <Text>{item.title}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
};
